import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="effective-attendance-rules--list"
export default class extends Controller {
  static targets = ["cloneButton", "deleteButton", "listContainer"];

  connect() {
  }

  edit(event) {
    const row = event.currentTarget;
    const dataAttr = row.dataset;

    Turbo.visit(dataAttr.editUrl, { frame: "effective-attendance-rule-form" });

    this.cloneButtonTarget.href = dataAttr.cloneUrl;
    this.deleteButtonTarget.href = dataAttr.deleteUrl;
    this.deleteButtonTarget.dataset.turboConfirm = `削除しますか？（${dataAttr.code}）`;

    this.resetActiveEntry();
    row.classList.add('selected');
  }

  resetActiveEntry() {
    this.listContainerTarget
      .querySelectorAll('.list-row')
      .forEach(tr => tr.classList.remove('selected'));
  }

}
